module.exports = __webpack_public_path__ + "img/employee-progress.26a7f74e.svg";